import axios from "axios";
import React, { useEffect, useRef } from "react";
import { API_BASE_URL } from "~/config";
import useAuth from "../utils/hooks/useAuth";

export const AxiosContext = React.createContext(
  axios.create({
    baseURL: API_BASE_URL,
    transformResponse: [],
  }),
);

type Props = {
  children: React.ReactNode;
};

export const AxiosProvider = ({ children }: Props): JSX.Element => {
  const { getToken } = useAuth();

  const client = useRef(
    axios.create({
      baseURL: API_BASE_URL,
      transformResponse: [],
    }),
  );

  useEffect(() => {
    const c = client.current;
    const interceptor = c.interceptors.request.use(
      async (config) => {
        try {
          const token = await getToken();
          return {
            ...config,
            headers: {
              ...config.headers,
              Authorization: `Bearer ${token ?? ""}`,
            },
          };
        } catch (error) {
          return Promise.reject(error);
        }
      },
      (err) => Promise.reject(err),
    );
    return () => {
      c.interceptors.request.eject(interceptor);
    };
  }, [getToken]);

  return (
    <AxiosContext.Provider value={client.current}>
      {children}
    </AxiosContext.Provider>
  );
};
